import { Box, Group, NullLogo, Text } from "@repo/ui/core";
import { useCustomer } from "@contexts/CustomerContext";

export function Footer() {
  const customer = useCustomer();

  return (
    <Box
      component="footer"
      py="md"
      px="xl"
      style={{
        borderTop: "1px solid var(--mantine-color-dark-4)",
        background: "var(--mantine-color-dark-8)",
      }}
    >
      <Group justify="space-between" align="center">
        <Text size="xs" c="dimmed" maw={600}>
          {customer.confidentialityNotice}
        </Text>
        <Group gap="lg">
          <NullLogo compact w={24} />
        </Group>
      </Group>
    </Box>
  );
}
